'use client';

import Link from 'next/link';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Container } from '~/components/Container';
import { HeadlineSubheadCta } from '~/components/HeadlineSubheadCta';
import type { AcfSponsors } from '~/types/graphql';

export function Sponsors({ sponsors }: AcfSponsors) {
  if (!sponsors?.sponsors) return null;

  return (
    <div className="px-[--site-margin] pb-16 pt-12 md:p-16">
      <Container className="gap-y-9 lg:gap-y-8">
        <HeadlineSubheadCta headline={sponsors?.headline ?? ''} />

        <Swiper
          id="sponsors"
          className="w-[100vw] !pb-0 max-md:-mx-[--site-margin] max-md:max-w-[100vw] max-md:px-[--site-margin] md:w-full"
          slidesPerView={1}
          spaceBetween={20}
          modules={[Pagination]}
          pagination={{ clickable: true }}
          breakpoints={{
            768: {
              slidesPerView: 'auto',
              spaceBetween: 32,
            },
            992: {
              slidesPerView: 4,
            },
          }}
        >
          {sponsors.sponsors?.map((sponsor, i) => {
            if (!sponsor?.image?.node?.sourceUrl) return null;

            return (
              <SwiperSlide
                className="flex flex-col gap-6 gap-y-6 md:max-w-[304px]"
                key={i}
              >
                <div className="flex w-full overflow-hidden rounded">
                  <Link href={sponsor.link ?? ''} target="_blank">
                    <img
                      className="aspect-square w-full object-cover"
                      src={sponsor.image.node.sourceUrl}
                      alt={sponsor.image.node.altText ?? ''}
                    />
                  </Link>
                </div>
              </SwiperSlide>
            );
          })}
          <style>{`
            #sponsors .swiper-pagination {
              position: static;
              display: flex;
              justify-content: center;
              margin-top: 36px;
              height: 10px;
            }
            #sponsors .swiper-pagination-bullet {
              background-color: #7a7a7a;
            }
            #sponsors .swiper-pagination-bullet-active {
              background-color: #000;
            }
            @media (min-width: 1200px) {
              #sponsors .swiper-wrapper {
                justify-content: flex-start;
                flex-wrap: wrap;
              }
              #sponsors .swiper-pagination {
                display: none;
              }
            }
          `}</style>
        </Swiper>
      </Container>
    </div>
  );
}
